export const environment = {
  COMPANYID: "MTY3MDU=",
  COMPANYURL: "dGVzdHRlc3R0ZXN0LnByZXByb2QxLm9wZW5pbmdzLmNvLyMhLy9tYW5hZ2U=",
  DOMAIN: "testtesttest.preprod1.openings.co",
  APIENDPOINT: "https://apipreprod1.zwayam.com/",
  APIENDPOINTNEW: "https://apipreprod1.zwayam.com/",
  JOBSHAREURL: "https://apipreprod1.zwayam.com"
};